import React, { useState, useCallback, useEffect } from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import Like from '../../assets/planshare icons/like.png';
import Saved from '../../assets/planshare icons/download.png';
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import ThreeDot from "react-loading-indicators/ThreeDot";
import Alert from '@mui/material/Alert';
import {
  Card, Typography, Button, RadioGroup, 
  CardContent,
  CardHeader,
  Checkbox,
  Avatar,
  Stack,
  Grid,
  Box,
  CardMedia, AvatarGroup, Select, MenuItem, Radio, FormControlLabel, TextField, InputLabel, FormHelperText
} from "@mui/material";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import { useDropzone } from "react-dropzone";
import GenericDialog from "../../components/GenericDialogBox/index";
import http from "../../utils/http-common";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  setPlanForDelete,
  setPlanForEdit,
  setPlanForShare,
  setPlanForView,
  setTemplateForEdit
} from "../../Slices/planslice";
function AddPlan({ onClose }) {
  const [categoryData, setCategoryData] = useState([]);
  const [templateType, setTemplateType] = useState("free");
  const RoleID = localStorage.getItem("role");
  const location = useLocation();
  const fetchCategoryData = async () => {
    const payload = { metadata_type: 'category' };
    try {
      const response = await http.post('/master_service/template/category_list', payload);
      const apiOptions = response.data.data.map((types) => ({
        label: types.metadata_name,
        value: types.metadata_name
      }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setCategoryData(apiOptions);
    } catch (error) {
      console.error('Error fetching Employee id options:', error);
    }
  };

  const [searchText, setSearchText] = useState("");
  const [costFilter, setCostFilter] = useState("All");
  const [templateTypes, setTemplateTypes] = useState("All");
  const [allTemplateData, setAllTemplateData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const FetchAllTemplates = async () => {
    try {
      const response = await http.get(
        "/master_service/template/list/data"
      );
      const myTemplates = response.data.My_Templates || [];
      const topPicks = response.data.Top_Picks || [];
      const featuredTemplates = response.data.Featured_Templates || [];

      // Combine all arrays
      const allTemplatesCombined = [...myTemplates, ...topPicks, ...featuredTemplates];

      // Deduplicate using a Map keyed by plan_id (you can change to "id" if needed)
      const uniqueTemplatesMap = new Map();

      allTemplatesCombined.forEach((template) => {
        if (!uniqueTemplatesMap.has(template.plan_id)) {
          uniqueTemplatesMap.set(template.plan_id, template);
        }
      });

      const uniqueTemplates = Array.from(uniqueTemplatesMap.values());
      setAllTemplateData(uniqueTemplates);
    } catch (e) {
      console.error("error", e);
    }
  };
  // Filtered template list
  const user_id = localStorage.getItem("user_id");
  const filteredTemplates = allTemplateData.filter(plan => {
    const matchesSearch = plan.plan_name.toLowerCase().includes(searchText.toLowerCase());
    const matchesCost = costFilter === "All" || plan.free_payable === costFilter;
    let matchesType = true;
    if (templateTypes === "Planshare") {
      matchesType = plan.user_id === user_id;
    } else if (templateTypes === "Community") {
      matchesType = plan.user_id !== user_id;
    }
    return matchesSearch && matchesCost && matchesType;
  });


  const ProjectCard = ({ title, createdBy, avatars, extraCount }) => {
    return (
      <Card
        variant='outlined'
        sx={{
          maxWidth: 200,
          borderRadius: 2,
        }}>
        <CardHeader
          title={
            <Stack
              direction='row'
              alignItems='center'
              justifyContent='space-between'>
              <Typography
                variant='h6'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: "14.52px",
                  textAlign: "left",
                  marginRight: "20px",
                }}>
                {title}
              </Typography>
              <Checkbox
                sx={{
                  "&.Mui-checked": {
                    color: "var(--Primary-Color, #FF2800)", // Color when checked
                  },
                }}
              />
            </Stack>
          }
          sx={{ pb: 0, backgroundColor: "#E5EEFB66" }}
        />
        <CardContent sx={{ px: 1, py: 0 }}>
          <CardMedia
            component='img'
            image={cardbackground}
            alt='Project Timeline'
            sx={{
              height: 60,
              borderRadius: 1,
              objectFit: "cover",
              backgroundColor: "#E5EEFB66",
            }}
          />

          <Box
            sx={{
              borderBottom: "1px solid #ccc",
              backgroundColor: "#E5EEFB66",
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "transparent",
            }}>
            <Box>
              <Typography
                variant='body1'
                color='textSecondary'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "10px",
                  fontWeight: 500,
                  lineHeight: "16px",
                  textAlign: "left",
                  marginTop: "5px",
                }}>
                Created by
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "10px",
                  fontWeight: 500,
                  lineHeight: "16px",
                  textAlign: "left",
                }}>
                {createdBy}
              </Typography>
            </Box>

            <Stack
              direction='row'
              alignItems='center'
              spacing={1}
              sx={{
                position: "relative",
                top: "4px",
                right: "0px",
                opacity: 1,
              }}>
              <AvatarGroup max={1}>
                {avatars.map((avatar, index) => (
                  <Avatar
                    key={index}
                    src={avatar}
                    alt={`avatar-${index}`}
                    sx={{ width: 24, height: 24 }}
                  />
                ))}
              </AvatarGroup>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (!planName.trim()) {
      toast.error("Please enter a valid Plan or Template Name");
      return;
    }
    if (!customerName.trim()) {
      toast.error("Please enter a valid Customer Name");
      return;
    }
    if (!isEdit && !isDelete && isTemplateToPlan && !selectedTemplate.unload_file_Path) {
      toast.error("Please select a template");
      return;
    }

    // Validate file only if it's not a blank plan
    if (!isBlankPlan && !isTemplateToPlan) {
      if (!uploadedFileName) {
        toast.error("Please upload a file");
        return;
      }

      const fileExtension = uploadedFileName.split(".").pop();
      if (!isTemplate && (fileExtension !== "MPP" && fileExtension !== "mpp")) {
        toast.error("Please upload a valid .mpp file");
        return;
      } else if (isTemplate && (fileExtension !== "MPT" && fileExtension !== "mpt")) {
        toast.error("Please upload a valid .mpt file");
        return;
      }
    }

    if (isTemplate && !category.trim()) {
      toast.error("Please enter a valid category");
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [planName, setPlanName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [planDescription, setPlanDescription] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [planId, setPlanId] = useState("");
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState("");

  const [planIdData, setPlanIdData] = useState(localStorage.getItem("planId") || "");
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setUploadedFileName(acceptedFiles[0].name);
      setUploadedFile(acceptedFiles[0]);
    } else {
      toast.error(
        <>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
            }}>
            Plan Upload Unsuccessfull
          </div>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "22px",
              textAlign: "left",
            }}>
            Something went wrong. Please check your file and try uploading again
          </div>
        </>
      );
    }
  }, []);
  const [selectedValue, setSelectedValue] = useState("no"); // State to track selected radio button
  const [error, setError] = useState(false); // State to track validation error

  const validate = () => {
    if (!selectedValue) {
      setError(true);
    }
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [jsonData, setJsonData] = useState([]);
  const handleCreatePlan = async () => {
    setLoading(true); // Start loading
    try {
      const formData = new FormData();
      formData.append("plan_name", planName);
      formData.append("customer_name", customerName);
      formData.append("plan_description", planDescription);
      formData.append("category", category);
      formData.append("tags", tags);
      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }
      // Add template-specific fields for Admin
      if (RoleID === "Admin") {
        formData.append("free_payable", templateType);
        if (templateType === "paid") {
          formData.append("currency", currency);
          formData.append("cost", templateCost);
        }
      }
      // Call template update API if isTemplate and isEdit are true
      if (isTemplate && isEdit) {
        formData.append("plan_id", planId);
        formData.append("id", planIdData);
        const response = await http.post("/master_service/create/template/plan", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 200) {
          toast.success(
            <>
              <div style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "8px",
              }}>
                Template Updated Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          handleNavigate("/admin/manage-templates")();
        }
        return;
      }
      if (!isTemplate) {
        if (isEdit) {
          formData.append("plan_id", planId);
          const response = await http.put(
            "/master_service/plan_update/records",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.status === 200) {
            const payload = {
              plan_id: planId
            };
            if (!isBlankPlan) {
              await new Promise((resolve) => setTimeout(resolve, 15000));
              const newResponse = await http.post("/master_service/plan/to/user/creation", payload);
            }
            toast.success(
              <>
                <div
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}>
                  Plan Updated Successfully
                </div>
              </>,
              {
                icon: (
                  <img
                    src={tick}
                    alt='Success Icon'
                    style={{ width: "20px", height: "20px", color: "#0057D5" }}
                  />
                ),
              }
            );
            try {
              const response = await http.post(`/master_service/store-plan-data`, {
                plan_id: planId,
              });
              if (response.status === 201) {
                const data = response.data;
              }
              if (response.status === 404) {
                setJsonData([]);
              }
            } catch (error) {
              //toast.error("Error fetching data");
              console.error("Error fetching view data", error);
            }
            handleNavigate("/home/myplans")();
          }
        } else if (isDelete) {
          const response = await http.delete(`/master_service/delete_plan/${planData.plan_id}`);
          if (response.status === 200) {
            toast.success(
              <>
                <div
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}>
                  Plan Deleted Successfully
                </div>
              </>,
              {
                icon: (
                  <img
                    src={tick}
                    alt='Success Icon'
                    style={{ width: "20px", height: "20px", color: "#0057D5" }}
                  />
                ),
              }
            );
            handleNavigate("/home/myplans")();
          }
        }
        else if (!isTemplate && isTemplateToPlan) {
          const formData = new FormData();
          formData.append("plan_name", planName);
          formData.append("customer_name", customerName);
          formData.append("plan_description", planDescription);
          formData.append("category", category);
          formData.append("tags", tags);
          const response = await http.post("/master_service/template/copy/as/plan", {
            user_id: localStorage.getItem("user_id"),
            plan_name: planName,
            customer_name: customerName,
            plan_description: planDescription,
            unload_file_Path: selectedTemplate.unload_file_Path
          });

          if (response.status === 200 || response.status === 201) {
            toast.success(
              <>
                <div
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}>
                  Template Converted to Plan Successfully
                </div>
              </>,
              {
                icon: (
                  <img
                    src={tick}
                    alt='Success Icon'
                    style={{ width: "20px", height: "20px", color: "#0057D5" }}
                  />
                ),
              }
            );
            handleNavigate("/home/myplans")();
            return; // 🔁 Exit function to avoid further plan creation steps
          } else {
            toast.error("Failed to convert template to plan.");
            setLoading(false);
            return;
          }
        }
        else {
          const response = await http.post("/master_service/plan", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (response.status === 201) {
            const planId = response.data.data.plan_id;
            const Id = response.data.data.id
            const payload = {
              plan_id: response.data.data.plan_id
            };
            if (isBlankPlan) {
const formatDate = (isoDate) => {
  if (!isoDate) return null;
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return null; // invalid date check

  // Set time to 00:00
  date.setHours(0, 0, 0, 0);

  // Format: YYYY-MM-DD HH:mm (will always be 00:00)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = "00";
  const minutes = "00";

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
              const today = new Date();
              const tomorrow = new Date(today);
              tomorrow.setDate(tomorrow.getDate() + 1);
              const payloadData = {
                plan_id: response.data.data.plan_id,
                data: {
                  tasks: [
                    {
                      id: 0,
                      Work: '8h',
                      cost: "0",
                      text: "Sample Project",
                      parent: "",
                      Critical: "False",
                      Priority: "[Priority value=500]",
                      duration: 2,
                      progress: 0,
                      end_date: formatDate(tomorrow),
                      Estimated: "False",
                      Milestone: "False",
                      ActivityID: "",
                      ActualCost: "0",
                      ActualWork: "0.0h",
                      Successors: "[]",
                      TotalSlack: "0.0d",
                      start_date: formatDate(today),
                      Predecessors: "[]",
                      ActivityCodes: "[]",
                      BaselineStart: "",
                      OverAllocated: "False",
                      ActualDuration: "0.0d",
                      BaselineFinish: "",
                      ConstraintDate: "",
                      ConstraintType: "AS_SOON_AS_POSSIBLE",
                      "Resource Names": "",
                      ActualWorkLabor: "",
                      BaselineDuration: "",
                      ResourceAssignments: '',
                      rendered_type: "project",
                      open: true,
                      _is_sample: true
                    },
                    {
                      id: 1,
                      Work: '8h',
                      cost: "0",
                      text: "Summary Task",
                      parent: "[Task id=0 uniqueID=0 name=Sample Project]",
                      Critical: "False",
                      Priority: "[Priority value=500]",
                      duration: 2,
                      progress: 0,
                      end_date: formatDate(tomorrow),
                      Estimated: "False",
                      Milestone: "False",
                      ActivityID: "",
                      ActualCost: "0",
                      ActualWork: "0.0h",
                      Successors: "[]",
                      TotalSlack: "0.0d",
                      start_date: formatDate(today),
                      Predecessors: "[]",
                      ActivityCodes: "[]",
                      BaselineStart: "",
                      OverAllocated: "False",
                      ActualDuration: "0.0d",
                      BaselineFinish: "",
                      ConstraintDate: "",
                      ConstraintType: "AS_SOON_AS_POSSIBLE",
                      "Resource Names": "",
                      ActualWorkLabor: "",
                      BaselineDuration: "",
                      ResourceAssignments: '',
                      rendered_type: "task",
                      open: true,
                      _is_sample: true
                    }
                  ]
                }
              };
              const newResponse = await http.post("/master_service/plan", payloadData);
            }
            if (!isBlankPlan) {
              await new Promise((resolve) => setTimeout(resolve, 15000));
              const newResponse = await http.post("/master_service/plan/to/user/creation", payload);
            }
            toast.success(
              <>
                <div
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}>
                  Plan Created Successfully
                </div>
                <div
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}>
                  Your new project is ready to go. Start sharing your plan with
                  users.
                </div>
              </>,
              {
                icon: (
                  <img
                    src={tick}
                    alt='Success Icon'
                    style={{ width: "20px", height: "20px", color: "#0057D5" }}
                  />
                ),
              }
            );
            try {
              setJsonData([]);
              const response = await http.post(`/master_service/store-plan-data`, {
                plan_id: planId
              });
              if (response.status === 201) {
                const data = response.data;
              }
              if (response.status === 404) {
                setJsonData([]);
              }
            } catch (error) {
              //toast.error("Error fetching data");
              console.error("Error fetching view data", error);
              setJsonData([]);
            }
            dispatch(setPlanForView({ id, isView: true, table: false }));
            localStorage.setItem("planId", Id);
            navigate(`/home/viewplan`);
          }
          if (response.status === 200) {
            toast.error(response.data.message);
          }
        }
      }
      else {
        const response = await http.post("/master_service/create/template/plan", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 201) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                Template Created Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          handleNavigate("/home/templates")();
        }
        if (response.status === 200) {
          toast.error(response.data.message);
        }
      }
    }
    catch (error) {
      console.error("Error creating plan:", error);
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, isEdit, isView, isDelete, table, isShare, isTemplate, isBlankPlan, isTemplateToPlan } = useSelector(
    (state) => state.planslice
  );
  useEffect(() => {
    if ((isEdit && id) || (isEdit && RoleID === 'Admin' && id) ||
      (isView && id) ||
      (isDelete && id) ||
      (isShare && id) && id !== planIdData) {
      setPlanIdData(id);
      localStorage.setItem("planId", id);
    }
  }, [id, planIdData, isEdit, isView, isDelete, isShare]);


  useEffect(() => {
    fetchCategoryData();
    FetchAllTemplates();
  }, []);

  useEffect(() => {

    if ((isEdit && planIdData) ||
      (isView && planIdData) ||
      (isDelete && planIdData) ||
      (isShare && planIdData)) {
      fetchPlanData(planIdData);
    }
  }, [planIdData, isEdit, isView, isDelete, isShare]);
  const resetFormData = () => {
    setPlanName("");
    setCustomerName("");
    setPlanDescription("");
    setUploadedFileName(null);
    setUploadedFile("");
    setPlanId("");
    setPlanData([]);
    setCategory("");
    setTags("");
  };
  const handleNavigate = (path) => () => {
    resetFormData(); // Reset all form data
    navigate(path);
    if (isEdit && RoleID !== 'Admin') {
      dispatch(setTemplateForEdit({ id: null, isTemplate: false, isBlankPlan: false, isTemplateToPlan: false }));
    }
    if (isEdit && RoleID === 'Admin') {
      dispatch(setTemplateForEdit({ id: null, isTemplate: false, isBlankPlan: false, isTemplateToPlan: false }));
    }
    if (isView) {
      dispatch(setPlanForView({ id: null, isView: false }));
    }
    if (isDelete) {
      dispatch(setPlanForDelete({ id: null, isDelete: false, isBlankPlan: false, isTemplateToPlan: false }));

    }
    if (isShare) {
      dispatch(setPlanForShare({ id: null, isShare: false }));
    }
    // Navigation logic
    if (isTemplate && RoleID === "Admin") {
      navigate("/admin/manage-templates");
    } else if (isTemplate) {
      // Non-admin but template → go to templates
      navigate("/home/templates");
    } else {
      // Default → go to given path
      navigate(path);
    }
  };
  // Update the useEffect cleanup
  useEffect(() => {
    return () => {
      resetFormData();
      dispatch(setPlanForEdit({ id: null, isEdit: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setTemplateForEdit({ id: null, isTemplate: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setPlanForView({ id: null, isView: false }));
      dispatch(setPlanForDelete({ id: null, isDelete: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setPlanForShare({ id: null, isShare: false }));
    };
  }, [location.pathname]);
  useEffect(() => {
    if (
      (isEdit && id) ||
      (isView && id) ||
      (isDelete && id) ||
      (isShare && id) ||
      (isBlankPlan && id) ||
      (isTemplateToPlan && id)
    ) {
      fetchPlanData();
    }
  }, [id, isEdit, isView, isDelete, isShare]);
  const [planData, setPlanData] = useState([]);
  const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/get_plan/${id || planIdData}`);
      if (response.status === 200) {
        const data = response.data;
        setPlanData(data);

        setPlanName(data.plan_name || "");
        setCustomerName(data.customer_name || "");
        setPlanDescription(data.plan_description || "");
        const uploadedFilePath = data.unload_file_Path || "";
        const fileName = uploadedFilePath.split("/").pop();
        setUploadedFileName(fileName);
        setUploadedFile(data.unload_file_Path || "");
        setPlanId(data.plan_id || "");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };
  useEffect(() => {
    if (
      (isEdit && id && isTemplate)
    ) {
      fetchTemplateData();
    }
  }, [id, isEdit, isTemplate]);
  const [currency, setCurrency] = useState("USD");
  const [templateCost, setTemplateCost] = useState("");
  const fetchTemplateData = async () => {
    try {
      const response = await http.get(`/master_service/template/view/data/${id}`);
      if (response.status === 200) {
        const data = response.data;
        setPlanData(data);
        setPlanName(data.plan_name || "");
        setCustomerName(data.customer_name || "");
        setPlanDescription(data.plan_description || "");
        const uploadedFilePath = data.unload_file_Path || "";
        const fileName = uploadedFilePath.split("/").pop();
        setUploadedFileName(fileName);
        setUploadedFile(data.unload_file_Path || "");
        setPlanId(data.plan_id || "");
        setCategory(data.category || "");
        setTags(data.tags || "");
        setTemplateCost(data.cost || "");
        setTemplateType(data.free_payable || "");
        setCurrency(data.currency || "");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setPlanForEdit({ id: null, isEdit: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setTemplateForEdit({ id: null, isTemplate: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setPlanForView({ id: null, isView: false }));
      dispatch(setPlanForDelete({ id: null, isDelete: false, isBlankPlan: false, isTemplateToPlan: false }));
      dispatch(setPlanForShare({ id: null, isShare: false }));
    };
  }, [location.pathname]);
  return (
    <div>
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "14.52px",
          textAlign: "left"
        }}>
        <span
          style={{ cursor: "pointer" }}
          onClick={handleNavigate("/home/myplans")}
        >{isTemplate && RoleID === "Admin" ? "Manage Template" : isTemplate ? "Search Plan" : "My Plans"}</span> &gt;{" "}
        {isEdit && RoleID === "Admin" ? "Edit Template" : isEdit && RoleID !== "Admin"
          ? "Edit Plan"
          : isView
            ? "View Plan"
            : isDelete
              ? "Delete Plan"
              : isTemplate
                ? "Create Template"
                : "Create Plan"}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "15px",
        }}>
        <ArrowBackIosNewRoundedIcon
          fontSize='small'
          onClick={handleNavigate("/home/myplans")}
        />
        <div
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "20px",
            fontWeight: 600,
            lineHeight: "21px",
            marginLeft: "8px",
          }}>
          {isEdit && RoleID === "Admin" ? "Edit Template" : isEdit && RoleID !== "Admin"
            ? "Edit Plan"
            : isView
              ? "View Plan"
              : isDelete
                ? "Delete Plan"
                : isTemplate
                  ? "Create Template"
                  : "Create Plan"}
        </div>
      </div>
      {isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "20px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Template Name{" "}
          <span
            style={{
              color: "#FF2800",
              //backgroundColor: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "60px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Template Name (max 100 characters)'
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
              inputProps={{ maxLength: 100 }}
              error={planName.length > 100}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Customer Name{" "}
          <span
            style={{
              color: "#FF2800",
              //backgroundColor: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: 57, flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Customer Name (max 150 characters)'
              value={customerName}
              inputProps={{ maxLength: 150 }}
              error={customerName.length > 150}
              onChange={(e) => setCustomerName(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
            marginBottom: "100px",
          }}>
          Template Description{" "}
        </Typography>
        <div style={{ marginLeft: "37px", flexGrow: 1 }}>
          <FormControl sx={{ height: "100px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Template Description (max 200 characters)'
              value={planDescription}
              inputProps={{ maxLength: 200 }}
              error={planDescription.length > 200}
              onChange={(e) => setPlanDescription(e.target.value)}
              multiline
              rows={4} // Specify the number of rows for multiline
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: 5,
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "15px",
            textAlign: "left",
            marginBottom: "55px",
          }}>
          Upload file{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: 87, flexGrow: 1 }}>
          <FormControl sx={{ height: "100px", width: "100%" }}>
            <div
              {...getRootProps()}
              style={{
                border: "1px solid lightgray",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                cursor: "pointer",
                borderRadius: "3px",
              }}>
              <input {...getInputProps()} />
              <Box sx={{ textAlign: "center" }}>
                <FileUploadOutlinedIcon
                  style={{ fontSize: "30px", color: "gray" }}
                />
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "gray",
                    marginTop: "5px",
                  }}>
                  Select a file or drag & drop the file
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px", // Updated to your preferred font size
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "center", // Center-align text
                    color: "#0057D5", // Updated text color
                    marginTop: "8px",
                  }}>
                  {uploadedFileName
                    ? `${uploadedFileName} file uploaded successfully`
                    : ""}
                </Typography>
              </Box>
            </div>
          </FormControl>
        </div>
      </div>)}
      {!isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "20px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Plan Name{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "60px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Plan Name (max 100 characters)'
              value={planName}
              inputProps={{ maxLength: 100 }}   // ✅ Correct way
              error={planName.length > 100}
              onChange={(e) => setPlanName(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {!isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Customer Name{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "23px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Customer Name (max 150 characters)'
              value={customerName}
              inputProps={{ maxLength: 150 }}
              error={customerName.length > 150}
              onChange={(e) => setCustomerName(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {!isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
            marginBottom: "100px",
          }}>
          Plan Description{" "}
        </Typography>
        <div style={{ marginLeft: "37px", flexGrow: 1 }}>
          <FormControl sx={{ height: "100px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Plan Description (max 200 characters)'
              value={planDescription}
              inputProps={{ maxLength: 200 }}
              error={planDescription.length > 200}
              onChange={(e) => setPlanDescription(e.target.value)}
              multiline
              rows={4} // Specify the number of rows for multiline
              sx={{
                height: "100%",

                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {(
        (
          (!isTemplate && !isTemplateToPlan && !isBlankPlan) ||
          (isTemplateToPlan && (isEdit || isDelete))
        ) &&
        !(isBlankPlan && isTemplateToPlan) // <-- exclude this combination
      ) && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "15px",
            textAlign: "left",
            marginBottom: "55px",
          }}>
          Upload file{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "60px", flexGrow: 1 }}>
          <FormControl sx={{ height: "100px", width: "100%" }}>
            <div
              {...getRootProps()}
              style={{
                border: "1px solid lightgray",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                cursor: "pointer",
                borderRadius: "3px",
              }}>
              <input {...getInputProps()} />
              <Box sx={{ textAlign: "center" }}>
                <FileUploadOutlinedIcon
                  style={{ fontSize: "30px", color: "gray" }}
                />
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "gray",
                    marginTop: "5px",
                  }}>
                  Select a file or drag & drop the file
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px", // Updated to your preferred font size
                    fontWeight: 500,
                    lineHeight: "20px",
                    textAlign: "center", // Center-align text
                    color: "#0057D5", // Updated text color
                    marginTop: "8px",
                  }}>
                  {uploadedFileName
                    ? `${uploadedFileName} file uploaded successfully`
                    : ""}
                </Typography>
              </Box>
            </div>
          </FormControl>
        </div>
      </div>)}
      {isTemplateToPlan && !isEdit && !isDelete && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "15px",
            textAlign: "left",
            marginBottom: "55px",
          }}>
          Select Template{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "25px", flexGrow: 1 }}>
          <FormControl sx={{ width: "100%" }}>
            <Box sx={{
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              backgroundColor: "white"
            }}>
              {/* Filters Section */}
              <Box sx={{ display: "flex", justifyContent: 'flex-end', gap: 2, flexWrap: "wrap", mb: 2 }}>
                <TextField
                  size="small"
                  label="Search"
                  variant="outlined"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  sx={{ height: '15px' }}
                />

                <FormControl size="small">
                  <InputLabel>Filter</InputLabel>
                  <Select
                    value={costFilter}
                    label="Cost"
                    onChange={(e) => setCostFilter(e.target.value)}
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="free">Free</MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small">
                  <InputLabel>Template Type</InputLabel>
                  <Select
                    value={templateTypes}
                    label="Template Type"
                    onChange={(e) => setTemplateTypes(e.target.value)}
                  >
                    <MenuItem value="All">All Templates</MenuItem>
                    <MenuItem value="Planshare">Planshare Templates</MenuItem>
                    <MenuItem value="Community">Community Templates</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {/* Scrollable Template Cards with Checkboxes */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  maxHeight: 320,
                  overflowY: "auto",
                  p: 1,
                }}
              >
                {filteredTemplates.map((plan, index) => (
                  <Card
                    key={plan.id}
                    variant="outlined"
                    sx={{
                      flex: "0 0 calc(32% - 6px)",
                      height: 150,
                      borderRadius: 2,
                      boxShadow: selectedTemplate?.id === plan.id ? 3 : 1,
                      margin: "1px",
                      position: "relative",
                      border: selectedTemplate?.id === plan.id ? "2px solid #FF2800" : "1px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        boxShadow: 2,
                      }
                    }}
                    onClick={() => setSelectedTemplate(plan)}
                  >
                    <CardHeader sx={{ pb: 0, backgroundColor: "#E5EEFB66" }} />
                    <CardContent sx={{ px: 1, py: 0 }}>
                      <Box sx={{ position: "relative", width: "100%", height: 100 }}>
                        <CardMedia
                          component="img"
                          image={cardbackground}
                          alt="Project Timeline"
                          sx={{
                            height: "90%",
                            width: "100%",
                            borderRadius: 1,
                            objectFit: "cover",
                            backgroundColor: "#0000001A",
                          }}
                        />
                        {/* Checkbox in top-right corner */}
                        <Checkbox
                          checked={selectedTemplate && selectedTemplate?.id === plan.id}
                          sx={{
                            position: "absolute",
                            top: -5,
                            right: -5,
                            color: "#FF2800",
                            '&.Mui-checked': {
                              color: "#FF2800",
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: 20,
                            }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedTemplate(selectedTemplate && selectedTemplate?.id === plan.id ? null : plan);
                          }}
                        />
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-start", flex: 1 }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left",
                                marginTop: "5px",
                              }}
                            >
                              {plan.plan_name}
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 500,
                                textAlign: "left",
                              }}
                            >
                              by {plan.created_by}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "flex-end", flex: 1, marginRight: "15px" }}></Box>
                          <Box sx={{ marginRight: "16px" }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 700,
                                lineHeight: "16px",
                                textAlign: "left",
                                marginTop: "5px",
                              }}
                            >
                              Cost
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 500,
                                lineHeight: "16px",
                                textAlign: "right",
                              }}
                            >
                              {plan.cost == null || plan.cost === "" || isNaN(Number(plan.cost)) ? "Free" : `$${plan.cost}`}
                            </Typography>
                          </Box>
                          <Box sx={{ marginRight: "12px" }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 700,
                                lineHeight: "16px",
                                textAlign: "right",
                                marginTop: "5px",
                              }}
                            >
                              Likes
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 500,
                                lineHeight: "16px",
                                textAlign: "right",
                              }}
                            >
                              {plan.likes ?? 0} <img src={Like} height="10px" width="10px" alt="like" />
                            </Typography>
                          </Box>
                          <Box sx={{ marginRight: "8px" }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 700,
                                lineHeight: "16px",
                                textAlign: "right",
                                marginTop: "5px",
                              }}
                            >
                              Saved
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "10px",
                                fontWeight: 500,
                                lineHeight: "16px",
                                textAlign: "right",
                              }}
                            >
                              {plan.top_pick_count ?? 0}  <img src={Saved} height="10px" width="10px" alt="saved" />
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Box>
          </FormControl>
        </div>
      </div>)}

      {!isEdit && !isView && !isDelete && isTemplate && RoleID !== "Admin" && (
        <Alert sx={{ marginLeft: 22, marginTop: 1 }} severity="info" color="warning">Note: Your plan will be saved as template and it will be publicly available for downloads, under a open source licence. Please don't share sensitive data.</Alert>

      )}
      {isEdit && !isView && !isDelete && isTemplate && RoleID === "Admin" && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Category{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "68px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              displayEmpty
              sx={{
                height: "100%",
                backgroundColor: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "left",
                marginLeft: 4,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            >
              <MenuItem value="" disabled>
                Enter Category
              </MenuItem>
              {categoryData.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>)}
      {isEdit && !isView && !isDelete && isTemplate && RoleID === "Admin" && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Tags{" "}
        </Typography>
        <div style={{ marginLeft: "110px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Tags'
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left"
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {!isEdit && !isView && !isDelete && isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Category{" "}
          <span
            style={{
              color: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "68px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              displayEmpty
              sx={{
                height: "100%",
                backgroundColor: "white",
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "left",
                marginLeft: 4,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            >
              <MenuItem value="" disabled>
                Enter Category
              </MenuItem>
              {categoryData.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>)}
      {!isEdit && !isView && !isDelete && isTemplate && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Tags{" "}
        </Typography>
        <div style={{ marginLeft: "110px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Tags'
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left"
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {!isEdit && !isView && !isDelete && isTemplate && RoleID === "Admin" && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Template Type{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "30px", flexGrow: 1 }}>
          <FormControl sx={{ marginLeft: 4 }}>
            <RadioGroup
              row
              value={templateType || 'free'}
              onChange={(e) => setTemplateType(e.target.value)}
            >
              <FormControlLabel
                value="free"
                control={<Radio style={{ color: "#FF2800" }} />}
                label={<Typography sx={{ fontSize: '14px' }}>Free</Typography>}
              />
              <FormControlLabel
                value="paid"
                control={<Radio style={{ color: "#FF2800" }} />}
                label={<Typography sx={{ fontSize: '14px' }}>Paid</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>)}
      {!isEdit && !isView && !isDelete && isTemplate && templateType === 'paid' && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Currency{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "65px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <Select
              value={currency || 'USD'}
              onChange={(e) => setCurrency(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                fontSize: "12px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "gray",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray",
                  },
                },
              }}
            >
              <MenuItem value="USD">USD ($)</MenuItem>
              <MenuItem value="EUR">EUR (€)</MenuItem>
              <MenuItem value="GBP">GBP (£)</MenuItem>
              <MenuItem value="INR">INR (₹)</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>)}
      {!isEdit && !isView && !isDelete && isTemplate && templateType === 'paid' && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Template Cost{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "30px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              type="number"
              placeholder="Enter Template Cost"
              value={templateCost}
              onChange={(e) => setTemplateCost(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                "& .MuiOutlinedInput-input": {
                  fontSize: "12px",
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left"
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "gray",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray",
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}
      {isEdit && !isView && !isDelete && isTemplate && RoleID === "Admin" && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Template Type{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "30px", flexGrow: 1 }}>
          <FormControl sx={{ marginLeft: 4 }}>
            <RadioGroup
              row
              value={templateType || 'free'}
              onChange={(e) => setTemplateType(e.target.value)}
            >
              <FormControlLabel
                value="free"
                control={<Radio style={{ color: "#FF2800" }} />}
                label={<Typography sx={{ fontSize: '14px' }}>Free</Typography>}
              />
              <FormControlLabel
                value="paid"
                control={<Radio style={{ color: "#FF2800" }} />}
                label={<Typography sx={{ fontSize: '14px' }}>Paid</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>)}
      {isEdit && !isView && !isDelete && isTemplate && templateType === 'paid' && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Currency{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "65px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <Select
              value={currency || 'USD'}
              onChange={(e) => setCurrency(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                fontSize: "12px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "gray",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray",
                  },
                },
              }}
            >
              <MenuItem value="USD">USD ($)</MenuItem>
              <MenuItem value="EUR">EUR (€)</MenuItem>
              <MenuItem value="GBP">GBP (£)</MenuItem>
              <MenuItem value="INR">INR (₹)</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>)}
      {isEdit && !isView && !isDelete && isTemplate && templateType === 'paid' && (<div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "5px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Template Cost{" "}
          <span style={{ color: "#FF2800", padding: "0 2px", borderRadius: "50%" }}>*</span>
        </Typography>
        <div style={{ marginLeft: "30px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              type="number"
              placeholder="Enter Template Cost"
              value={templateCost}
              onChange={(e) => setTemplateCost(e.target.value)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                marginLeft: 4,
                "& .MuiOutlinedInput-input": {
                  fontSize: "12px",
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left"
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray",
                  },
                  "&:hover fieldset": {
                    borderColor: "gray",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray",
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>)}

      <Box display='flex' justifyContent='flex-end' p={1}>
        <Button
          variant='contained'
          onClick={handleNavigate("/home/myplans")}
          sx={{
            fontFamily: "Inter, sans-serif",
            textTransform: "none",
            fontWeight: 500,
            backgroundColor: "#FAFAFA",
            "&:hover": {
              backgroundColor: "#FAFAFA",
            },
            padding: "4px 12px",
            color: "black",
            border: "1px solid black",

            marginRight: "10px",
          }}>
          Back
        </Button>
        <Button
          variant='contained'
          onClick={handleOpen}
          sx={{
            fontFamily: "Inter, sans-serif",
            textTransform: "none",
            fontWeight: 500,
            backgroundColor: "#FF2800",
            padding: "4px 12px",
            "&:hover": {
              backgroundColor: "#FF2800",
            },
          }}>
          {isEdit && isTemplate && RoleID === 'Admin' ? "Update Template" : isEdit && RoleID !== 'Admin' ? "Update Plan" : isDelete ? "Delete Plan" : isTemplate ? "Create Template" : "Create Plan"}
        </Button>
      </Box>
      <GenericDialog
        open={open}
        onClose={handleClose}
        title='Create New User'
        content={
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "23.5px",
                textAlign: "left",
              }}>
              {isEdit
                ? "Update Plan"
                : isDelete
                  ? "Delete Plan"
                  : isTemplate
                    ? "Create Template"
                    : "Create Plan"}
            </div>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
                textAlign: "left",
                marginTop: "12px",
              }}>
              {isEdit
                ? "Are you sure you want to update this plan?"
                : isDelete
                  ? "Are you sure you want to delete this plan?"
                  : isTemplate
                    ? "Are you sure you want to create this template?"
                    : "Are you sure you want to create this plan?"}
            </div>
            <Box display='flex' p={1}>
              <Button
                variant='contained'
                fullWidth
                onClick={handleClose}
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FAFAFA",
                  "&:hover": {
                    backgroundColor: "#FAFAFA",
                  },
                  padding: "6px 16px",
                  color: "black",
                  border: "1px solid black",

                  marginRight: "10px",
                }}>
                Cancel
              </Button>
              <Button
                variant='contained'
                fullWidth
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FF2800",
                  padding: "6px 16px",
                  "&:hover": {
                    backgroundColor: "#FF2800",
                  },
                }}
                onClick={handleCreatePlan}
                disabled={loading}>
                {loading ? (
                  <ThreeDot variant='pulsate' color='#FF2800' size='small' />
                ) : (
                  "Proceed"
                )}
              </Button>
            </Box>
          </>
        }
        maxWidth='xs'
        button={<Button onClick={handleClose}>Close</Button>}
        noBackGround={false}
        fullScreen={false}
      />
    </div>
  );
}

export default AddPlan;
